import { check as checkFF } from '@webapp-next/lib/feature-flag';
import getVueEventBus from '@webapp-next/lib/vue-event-bus';
import HELP_EVENTS from '@webapp-next/modules/help-center/events';
import getBusinessName from '@/modules/locations-setup/facades/get-business-name';
import getOriginalHostname from '@/lib/facades/get-original-hostname';
import { ddLogInfo, ddLogError } from '@webapp-next/lib/utils/dd-log';

// TODO: unify zE, zESettings and window.ZENDESK under window.APP.LIBS.ZENDESK
// for better visibility, add a confluence doc link on how it all works together

export async function loadZendeskWidget() {
  if (!window.__ZENDESK__) {
    return;
  }

  const { url } = window.__ZENDESK__;

  // Use the loginUser method for authentication
  zE('messenger', 'loginUser', function(callback) {
    fetch(url).then(res => {
      res.text().then(jwt => {
        callback(jwt);
      });
    });
  });

  _setupZendeskWatchers();
  _setConversationFields();
}

function _setConversationFields() {
  // Feature flag to enable/disable conversation fields for gen AI support
  if (!checkFF('wo-2679-zendesk-gen-ai')) {
    return;
  }

  zE(() => {
    const businessName = getBusinessName() || '';
    const hostnameUrl = window.location.hostname || getOriginalHostname() || '';

    const conversationFields = [];

    if (businessName) {
      conversationFields.push({
        id: '360042644653',
        value: businessName,
      });
    } else {
      ddLogError('Zendesk conversation field: business name is empty', {
        context: 'zendesk-widget',
        metadata: {
          fieldId: '360042644653',
          fieldName: 'businessName',
        },
      });
    }

    if (hostnameUrl) {
      conversationFields.push({
        id: '360042389174',
        value: hostnameUrl,
      });
    } else {
      ddLogError('Zendesk conversation field: hostname URL is empty', {
        context: 'zendesk-widget',
        metadata: {
          fieldId: '360042389174',
          fieldName: 'hostnameUrl',
        },
      });
    }

    if (conversationFields.length > 0) {
      zE('messenger:set', 'conversationFields', conversationFields);
      ddLogInfo('Zendesk conversation fields set successfully', {
        context: 'zendesk-widget',
        metadata: {
          fieldsSet: conversationFields.map(f => f.id),
          businessName: businessName || null,
          hostnameUrl: hostnameUrl || null,
        },
      });
    }
  });
}

function _setupZendeskWatchers() {
  zE('messenger:on', 'unreadMessages', function(messages) {
    getVueEventBus().$emit(HELP_EVENTS.ZENDESK_MESSAGE_UPDATE, messages);
  });
  zE('messenger:on', 'close', function() {
    getVueEventBus().$emit(HELP_EVENTS.ZENDESK_MESSAGE_UPDATE, 0);
  });
}
